
{
  "en": {
    "You have not participated in any GIP lunches yet": "You have not participated in any GIP lunches yet"
  },
  "ja": {
    "You have not participated in any GIP lunches yet": "まだGIPランチ参加していません"
  }
}
